import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[650px] md:min-h-[750px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20abstract%20background%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20red%20and%20deep%20dark%20tones%2C%20subtle%20geometric%20patterns%2C%20sophisticated%20ambient%20lighting%2C%20professional%20streaming%20platform%20atmosphere%2C%20premium%20visual%20aesthetic%2C%20smooth%20elegant%20composition%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lights&width=1920&height=1080&seq=hero-bg-main-01&orientation=landscape"
          alt="芭乐视频背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-star-line text-accent-400 text-sm"></i>
            <span className="text-background-50/90 text-sm">红桃视频 · 樱花视频 · 糖豆视频 联合推荐</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-5 leading-tight">
            {heroData.title}
          </h1>

          <p className="text-lg md:text-xl text-background-50/70 max-w-2xl mb-3">
            {heroData.subtitle}
          </p>

          <p className="text-sm md:text-base text-background-50/50 max-w-xl mb-10 leading-relaxed">
            {heroData.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 mb-14">
            <Link
              to="/category/dianshiju"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-base whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105"
            >
              <i className="ri-play-circle-fill mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-background-50 font-medium rounded-lg text-base whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/20"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12">
            {heroData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-background-50/50">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}